module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c(_vm.type, {
    tag: "component",
    staticClass: "c-btn-text u-relative u-inline-block",
    attrs: {
      "to": _vm.to,
      "href": _vm.href
    }
  }, [_c('span', {
    staticClass: "u-invisible u-inline-block",
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "u-absolute u-pos-tl u-fit u-overflow-h u-inline-block"
  }, [_c('span', {
    staticClass: "c-btn-text__text u-inline-block u-absolute u-pos-tl u-fit u-overflow-h",
    class: [_vm.classDefault]
  }, [_c('span', {
    staticClass: "c-btn-text__text-content u-inline-block",
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "c-btn-text__over u-inline-block u-absolute u-pos-tl u-fit u-overflow-h",
    class: [_vm.classOver]
  }, [_c('span', {
    staticClass: "c-btn-text__over-content u-inline-block",
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55ef11c6"}!./src/scripts/components/app-text-mask/template.html
// module id = 919
// module chunks = 0